import React from 'react';
import PropTypes from 'prop-types';
import {
    SiteStructure,
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eb/site-structure';

const Page = ({
    env,
    request,
    user,
    footerLinks,
    isLoading,
    children,
    featureFlags,
}) => (
    <SiteStructure
        env={env}
        request={request}
        user={user}
        footerLinks={footerLinks}
        isLoading={isLoading}
        fullScreenMain={true}
        featureFlags={featureFlags}
    >
        {children}
    </SiteStructure>
);

Page.propTypes = {
    env: ENV_SHAPE_PROP_TYPE.isRequired,
    request: REQUEST_SHAPE_PROP_TYPE.isRequired,
    user: USER_SHAPE_PROP_TYPE.isRequired,
    footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
    isLoading: PropTypes.bool,
};

export default Page;
